import { render, staticRenderFns } from "./AccountHistoryVpp.vue?vue&type=template&id=5a56b619&"
import script from "./AccountHistoryVpp.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryVpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports